import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "section"]
  static values = { storageKey: String }

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    this.persistSections = this.persistSections.bind(this)

    this.restoreSectionState()
    this.sectionTargets.forEach((section) => {
      section.addEventListener("toggle", this.persistSections)
    })
    this.persistSections()

    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    this.sectionTargets.forEach((section) => {
      section.removeEventListener("toggle", this.persistSections)
    })
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.element.classList.add("admin-shell--sidebar-open")
    this.triggerTargets.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true")
    })
  }

  close() {
    this.element.classList.remove("admin-shell--sidebar-open")
    this.triggerTargets.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false")
    })
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  restoreSectionState() {
    const state = this.loadSectionState()
    if (!state) return

    this.sectionTargets.forEach((section) => {
      const key = section.dataset.adminSidebarSectionKey
      if (!key || !(key in state)) return

      section.open = section.open || Boolean(state[key])
    })
  }

  persistSections() {
    if (!this.sectionTargets.length) return

    const state = {}
    this.sectionTargets.forEach((section) => {
      const key = section.dataset.adminSidebarSectionKey
      if (key) state[key] = section.open
    })

    try {
      window.localStorage.setItem(this.sectionStorageKey, JSON.stringify(state))
    } catch (_error) {
      // Sidebar disclosure state is a convenience; navigation still works without it.
    }
  }

  loadSectionState() {
    try {
      const rawState = window.localStorage.getItem(this.sectionStorageKey)
      if (!rawState) return null

      const parsedState = JSON.parse(rawState)
      if (!parsedState || Array.isArray(parsedState) || typeof parsedState !== "object") return null

      return parsedState
    } catch (_error) {
      return null
    }
  }

  get isOpen() {
    return this.element.classList.contains("admin-shell--sidebar-open")
  }

  get sectionStorageKey() {
    return this.hasStorageKeyValue ? this.storageKeyValue : "chronoa.admin-sidebar.sections"
  }
}
